import React, { useState, useRef } from "react";

import "./sign-request-by-volume-upload-files.css";
import { ButtonHLPure, LabelErrorPure, LabelHLPure, TextAreaHLPure } from "../../pures";

const formatExample = `nombredearchivo001.pdf,correoA@electronico.com.mx,nombre del firmanteA, apellidos del firmarteA 
nombredearchivo002.pdf,correoB@electronico.com.mx,nombre del firmanteB, apellidos del firmarteB 
nombredearchivo003.pdf,correoC@electronico.com.mx,nombre del firmanteC, apellidos del firmarteC 
nombredearchivo004.pdf,correoD@electronico.com.mx,nombre del firmanteD, apellidos del firmarteD 
nombredearchivo005.pdf,correoE@electronico.com.mx,nombre del firmanteE, apellidos del firmarteE `;

const SignRequestByVolumeUploadFilesView = (props) => {
  const { step, onHandleBack, onHandleNext, onHandleLoad, t } = props;
  const { next, back, load } = step;
  const [fileCsv, setFileCsv] = useState();
  const [textFileCsv, setTextFileCsv] = useState("");
  const inputFile = useRef(null);
  const fileReader = new FileReader();
  const [persistedCsv] = useState(props.csvJsonAsText);
  const [errorInCsvUpload, setErrorInCsvUpload] = useState(false);

  const checkSpecialCharacters = (str) => {
    const cleanData = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const noSpecialCharsRegExp = new RegExp(
      /^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ/;:¿?¡!()"'&]+$/
    );

    return cleanData !== str || noSpecialCharsRegExp.test(str)
      ? setErrorInCsvUpload(true)
      : setErrorInCsvUpload(false);
  };

  const processCSV = (str) => {
    setTextFileCsv(str);
  };

  const handleUpload = () => {
    inputFile.current.click();
  };

  const handleOnChange = (e) => {
    setFileCsv(e.target.files[0]);
    const csvFile = e.target.files[0];
    fileReader.onload = (e) => {
      const text = e.target.result;
      checkSpecialCharacters(text);
      processCSV(text);
    };

    fileReader.readAsText(csvFile);
  };

  const onHandleSubmit = (e) => {
    onHandleNext(e);
    onHandleLoad(fileCsv, textFileCsv);
  }

  return (
    <div className="card-description-reliable">
      <LabelHLPure 
        text={t("signRequestByVolumeUploadFilesView.instructions")}
        fontSize={'16px'}
        showTooltip={false}
      />
      <input
        type="file"
        id="file"
        ref={inputFile}
        accept=".csv"
        onChange={handleOnChange}
        style={{ display: "none" }}
      />
      {textFileCsv ? (
        <TextAreaHLPure
          valueTextData={textFileCsv || ""}
          readOnly={true}
        />
      ) : persistedCsv ? (
        <TextAreaHLPure
          valueTextData={persistedCsv || ""}
          readOnly={true}
        />
      ) : (
        <TextAreaHLPure
          valueTextData={formatExample || ""}
          readOnly={true}
        />
      )}
      {errorInCsvUpload ? (
        <LabelErrorPure label={t("signRequestByVolumeUploadFilesView.error")}/>
      ) : null}
      <div className="action-buttons">
        <ButtonHLPure
          nameBtn={back}
          primary={false}
          onClickBtn={(event) => onHandleBack(event)}
        />
        <ButtonHLPure
          nameBtn={load}
          primary={false}
          onClickBtn={(event) => handleUpload(event)}
        />
        <ButtonHLPure
          nameBtn={next}
          primary={true}
          onClickBtn={(event) => onHandleSubmit(event)}
          disabled={!fileCsv || errorInCsvUpload}
        />
      </div>
    </div>
  );
};

export default SignRequestByVolumeUploadFilesView;
